module.exports = __webpack_public_path__ + "static/GooglePlayIcon-60ea0ba7c44a83288f13b87680162faf.png";